import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { combineLatest, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { LIB_CONFIG, LibConfig } from '../../../lib.config';
import { SuchwortService } from '../../../services/suchseite/suchwort.service';
import { BerufeService } from '../../../services/suchseite/berufe.service';
import { ReferrerService } from '../../../services/suchseite/referrer.service';

@Component({
  selector: 'now-wbsuche-lib-berufe-empty-state',
  templateUrl: './berufe-empty-state.component.html',
  styleUrls: ['./berufe-empty-state.component.scss'],
  imports: [NgOptimizedImage, AsyncPipe]
})
export class BerufeEmptyStateComponent {
  private readonly libConfig = inject<LibConfig>(LIB_CONFIG);
  private readonly berufeService = inject(BerufeService);
  private readonly referrerService = inject(ReferrerService);
  private readonly suchwortService = inject(SuchwortService);

  public context$ = combineLatest([
    this.referrerService.origin$,
    this.referrerService.berufeRef$
  ]).pipe(
    map(([origin, ref]) => {
      switch (origin) {
        case 'NEWPLAN':
          return {
            url: !!ref ? `${this.libConfig.newPlanBasePath}${ref}` : '',
            buttonText: 'Zurück zu New Plan',
            helpText:
              'Für die gewählte Aufstiegsweiterbildung sind derzeit keine Angebote verfügbar.\nDurch die Anzeige der Alternativen wird das Ergebnis Ihres New Plan-Online-Tests nicht mehr berücksichtigt.'
          };
        case 'BNET':
          return {
            url: !!ref ? `${this.libConfig.baBasePath}${ref}` : '',
            buttonText: 'Zurück zu BERUFENET',
            helpText:
              'Für die gewählte Weiterbildung sind derzeit keine Angebote verfügbar.\nDurch die Anzeige der Alternativen werden ähnliche vorhandene Weiterbildungsangebote zum zuvor ausgewählten Beruf ermittelt.'
          };
        default:
          return {
            url: null,
            linkText: null,
            helpText:
              'Für die gewählte Weiterbildung sind derzeit keine Angebote verfügbar.\nDurch die Anzeige der Alternativen werden ähnliche vorhandene Weiterbildungsangebote zum zuvor ausgewählten Beruf ermittelt.'
          };
      }
    })
  );
  public showSearchButton$ = this.berufeService.bezeichnung$.pipe(
    map((bezeichnung) => bezeichnung.length > 0)
  );

  triggerSearch() {
    this.berufeService.bezeichnung$.pipe(take(1)).subscribe((bezeichnung) => {
      this.suchwortService.setSuchwortUndSucheDirekt(bezeichnung);
    });
  }
}
